import Modal from "@ui-components/Modal";
import {AddContactUserModalProps} from "./types";
import {useState} from "react";
import {useIntl, FormattedMessage} from "react-intl";
import {ExclamationCircleIcon} from "@heroicons/react/24/outline";
import { validateEmail } from "@utils/validate-email";
import Input from "@ui-components/Input";
import Button from "@ui-components/Button";
import apiRequest from "@services/apiRequest";

export const AddContactUserModal = ({
  onConfirm,
  onExit
}: AddContactUserModalProps) => {
  const intl = useIntl();
  const [emailUserToAdd, setEmailUserToAdd] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  return <Modal
    onExit={onExit}
  >
    <div className={"p-5"}>
      <div className={"flex flex-row gap-x-5"}>
        <Input
          label={"Email"}
          value={emailUserToAdd}
          onChange={(e) => setEmailUserToAdd(e.target.value)}
          placeholder={intl.formatMessage(
            {
              id: "insert_email",
              defaultMessage: "insersci l'email dell'utente"
            }
          )}
        />
        {emailUserToAdd && !validateEmail(emailUserToAdd) &&
          <div className="flex flex-row items-center gap-1.5 text-red-500 text-sm mt-3">
            <ExclamationCircleIcon className="w-6"/>
            <FormattedMessage
              id="invalid_email"
              defaultMessage="L'indirizzo email inserito non è valido"
            />
          </div>
        }
      </div>
      <div className={"flex w-full justify-center gap-x-2 "}>
        <Button
          disabled={!validateEmail(emailUserToAdd) || !emailUserToAdd}
          onClick={async () => {
            setLoading(true);
            await onConfirm(emailUserToAdd);
            setLoading(false);
            onExit();
          }}
          submitting={loading}
        >
          {intl.formatMessage({
            id: "confirm",
            defaultMessage: "Conferma"
          })}
        </Button>
        <Button
          onClick={onExit}
          styleType={"empty"}
          disabled={loading}
        >
          {intl.formatMessage({
            id: "cancel",
            defaultMessage: "Annulla"
          })}
        </Button>
      </div>
    </div>
  </Modal>
}